export default {
	'Are you sure you want to restore all configurations to the default values?': '确定要恢复全部配置到默认值吗？',
	'Background color when hovering over the top bar': '顶栏悬停时背景色',
	'Background page switching animation': '后台页面切换动画',
	classic: '经典',
	'Dark mode': '暗黑模式',
	default: '默认',
	'Double column': '双栏',
	'Exit full screen': '退出全屏',
	'Full screen is not supported': '您的浏览器不支持全屏，请更换浏览器再试~',
	'Layout configuration': '布局配置',
	'Layout mode': '布局方式',
	Login: '登录',
	'Login to the buildadmin': '登录到 BuildAdmin 开源社区',
	Logout: '注销',
	'Member center': '会员中心',
	'Member information': '会员信息',
	'overall situation': '全局',
	Password: '密码',
	'Please enter buildadmin account name or email': '请输入 BuildAdmin 账户名/电子邮箱/手机号',
	'Please enter the buildadmin account password': '请输入 BuildAdmin 账户密码',
	'Please select an animation name': '请选择动画名称',
	Profile: '个人资料',
	Register: '没有账户？去注册',
	'Restore default': '恢复默认',
	'Show side menu top bar (logo bar)': '显示侧边菜单顶栏(LOGO栏)',
	'Side menu accordion': '侧边菜单手风琴',
	'Side menu active item background color': '侧边菜单激活项背景色',
	'Side menu active item text color': '侧边菜单激活项文字色',
	'Side menu bar background color': '侧边菜单栏背景色',
	'Side menu default icon': '侧边菜单默认图标',
	'Side menu horizontal collapse': '侧边菜单水平折叠',
	'Side menu text color': '侧边菜单文字颜色',
	'Side menu top bar background color': '侧边菜单顶栏背景色',
	'Side menu width (when expanded)': '侧边菜单宽度(展开时)',
	sidebar: '侧边栏',
	'Single column': '单栏',
	'Top bar': '顶栏',
	'Top bar background color': '顶栏背景色',
	'Top bar menu active item background color': '顶栏菜单激活项背景色',
	'Top bar menu active item text color': '顶栏菜单激活项文字色',
	'Top bar text color': '顶栏文字色',
	Username: '用户名',
}
